import { render, staticRenderFns } from "./contentSetting.vue?vue&type=template&id=b2ac7b02&scoped=true&"
import script from "./contentSetting.vue?vue&type=script&lang=js&"
export * from "./contentSetting.vue?vue&type=script&lang=js&"
import style0 from "./contentSetting.vue?vue&type=style&index=0&id=b2ac7b02&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2ac7b02",
  null
  
)

export default component.exports